import { alertRequest, body, request } from "services/request";

const resource = "api/organization";

const block = (params: {}) => alertRequest(`${resource}/block`, body(params));

const getItem = () => request(`${resource}/get`, { method: "GET" });

const invite = (params: {}) => alertRequest(`${resource}/invite`, body(params));

export { block, getItem, invite };
